import { useEffect, useState } from "react";
import recruit from "../assets/dummy/DataRecruit.json";

function CompRecruit(props) {
  const [data, setData] = useState({});
  const id = Number(props.match.params.id) - 1;

  useEffect(() => {
    setData(recruit.Recruit[id]);
  }, [data, id]);

  return (
    <>
      {data ? (
        <div className="inner">
          <h2 className="basic-title">{data.title}</h2>
          <div className="basic-subtitle">{data.contheader}</div>
          <div className="recruit-wrap">
            <div>
              <ul
                className="recruit-cont"
                dangerouslySetInnerHTML={{ __html: data.contents }}
              ></ul>
            </div>
            <div className="recruit-apply">
              <h3 className="recruit-apply-title">
                <span className="txt">헬리오센과 함께 할</span>
                <span className="txt">여러분을 기다립니다.</span>
              </h3>
              <button className="black-btn" onClick={()=>{window.open(data.url)}}>지원하기</button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default CompRecruit;
